interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  progressPercent: number;
  onStepClick?: (step: number) => void;
}

export default function StepProgress({
  currentStep,
  totalSteps,
  stepLabels,
  progressPercent,
  onStepClick
}: StepProgressProps) {
  return (
    <div className="mb-5">
      <div className="flex justify-between items-center mb-4 sm:mb-6">
        <div className="text-xs sm:text-sm text-gray-600">
          Step {currentStep} of {totalSteps}
        </div>
        <div className="text-xs sm:text-sm text-gray-600">
          {progressPercent}% complete
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 mb-4 sm:mb-6">
        <div
          className="bg-gray-800 h-2 rounded-full transition-all duration-300"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      {/* Step Navigation */}
      <div className="flex gap-1 sm:gap-2">
        {Array.from({ length: totalSteps }, (_, index) => {
          const step = index + 1;
          return (
            <button
              key={step}
              onClick={() => onStepClick?.(step)}
              className={`flex-1 px-2 sm:px-4 lg:px-6 py-2 sm:py-3 rounded-lg text-xs sm:text-sm font-medium transition-colors min-h-[40px] sm:min-h-[44px] touch-manipulation ${
                step === currentStep
                  ? "bg-gradient-to-b from-[#403634] to-[#1E1E1E] text-white"
                  : "bg-[#B5AEAD] text-white"
              }`}
            >
              <span className="hidden sm:inline">{stepLabels[index]}</span>
              <span className="sm:hidden">{step}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}